document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.shopify-email-marketing-confirmation__container');
  if (!container) return;

  const currentText = container.textContent.toLowerCase();
  const isPending = currentText.includes('letzter schritt') || currentText.includes('anmeldelink');
  const isSubscribed =
    currentText.includes('mailingliste') ||
    currentText.includes('erfolgreich angemeldet') ||
    currentText.includes('jederzeit wieder abmelden');

  if (!isPending && !isSubscribed) return;

  const existingLogo = document.querySelector('.header__heading-logo');

  function addBrand() {
    const brand = document.createElement('a');
    brand.className = 'heldy-newsletter-confirmation__brand';
    brand.href = '/';
    brand.setAttribute('aria-label', 'Heldy Startseite');

    if (existingLogo) {
      const logo = document.createElement('img');
      logo.className = 'heldy-newsletter-confirmation__logo';
      logo.src = existingLogo.currentSrc || existingLogo.src;
      logo.alt = existingLogo.alt || 'Heldy';
      logo.width = existingLogo.naturalWidth || 160;
      logo.height = existingLogo.naturalHeight || 80;
      brand.appendChild(logo);
    } else {
      brand.textContent = 'Heldy';
    }

    container.prepend(brand);
  }

  document.body.classList.add('heldy-newsletter-confirmation-page');
  container.classList.add('heldy-newsletter-confirmation--enhanced');

  if (isPending) {
    container.innerHTML = `
      <h1 class="heldy-newsletter-confirmation__title">Nur noch ein Schritt.</h1>
      <p class="heldy-newsletter-confirmation__text">
        Schön, dass du Teil der Heldy Community werden möchtest.
      </p>
      <p class="heldy-newsletter-confirmation__text">
        Wir haben dir gerade eine E-Mail geschickt. Klicke dort auf den
        <strong>Bestätigungslink</strong>, damit du künftig Neuigkeiten von Heldy erhältst.
      </p>
      <p class="heldy-newsletter-confirmation__note">
        Keine E-Mail da? Bitte prüfe auch deinen Spam-Ordner.
      </p>
    `;
    addBrand();
    return;
  }

  container.innerHTML = `
      <h1 class="heldy-newsletter-confirmation__title">Schön, dass du dabei bist.</h1>
      <p class="heldy-newsletter-confirmation__text">
        Deine Anmeldung war erfolgreich. Ab jetzt erfährst du zuerst von neuen Motiven,
        besonderen Aktionen und Geschichten rund um Heldy.
      </p>
      <p class="heldy-newsletter-confirmation__note">
        Deinen Rabattcode erhältst du in einer separaten E-Mail.
      </p>
      <a class="heldy-newsletter-confirmation__button" href="/collections/socken">
        Socken entdecken
      </a>
    `;
  addBrand();
});
